import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  input,
  model,
  Output,
  signal,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Installer, UsersService } from '@ubie/core';
import { FeedbackService, FormHelper } from '@ubie/shared';
import { AccountRegistrationSliderEvent } from '../../../interfaces/account-registration-slider-event.interface';

@Component({
  selector: 'acl-register-company-details',
  standalone: false,
  templateUrl: './register-company-details.component.html',
  styleUrl: './register-company-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegisterCompanyDetailsComponent {
  private readonly formBuilder = inject(FormBuilder);
  private readonly userService = inject(UsersService);
  private readonly feedbackService = inject(FeedbackService);

  readonly slideNo = input<number>(2);
  readonly installer = model.required<Installer>();

  @Output() readonly slideTo =
    new EventEmitter<AccountRegistrationSliderEvent>();

  // Define form using the builder
  readonly professionalDetailsForm: FormGroup = this.formBuilder.group({
    companyname: ['', [Validators.required]],
    vatno: ['', [Validators.required]],
    telephone: [
      '',
      [Validators.pattern(/^\+?[0-9()\-\s]{7,20}$/), Validators.maxLength(20)],
    ],
    terms: [false, [Validators.requiredTrue]], // Validation for checkbox
  });
  readonly isFormSubmitAttempted = signal(false);

  // init form helper for validation
  readonly formHelper = new FormHelper(this.professionalDetailsForm);

  goBack(): void {
    this.slideTo.emit({ slideNo: 1, user: this.installer() });
  }
  submitDetails(): void {
    this.isFormSubmitAttempted.set(true);
    if (this.professionalDetailsForm.valid) {
      this.installer.update((installer) => {
        return {
          ...installer,
          ...this.professionalDetailsForm.value,
        };
      });

      this.userService.updateInstallerUser(this.installer()).subscribe({
        next: () => {
          this.slideTo.emit({
            slideNo: this.slideNo(),
            user: this.installer(),
          });
        },
        error: () => {
          this.feedbackService.present('register_emailError');
        },
      });
    }
  }
}
